// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__b2-Hj","fileBtn":"File_fileBtn__264GU","closeBtn":"File_closeBtn__2hUWK","fileSelected":"File_fileSelected__m25Vv","disabled":"File_disabled__BPbhZ"};